/**
 * A casca das telas que têm menu lateral.
 *
 * ⚠️ NO-OP PARA QUEM NÃO DECLAROU A MARCA. Os dois hosts servem o MESMO bundle;
 * sem esta guarda o 12brain Academy ganharia um menu que ninguém pediu — e ele
 * é a TESTEMUNHA de escopo deste repo. Marca fora de `MARCAS_COM_MENU_LATERAL`
 * recebe `children` cru, byte a byte como antes.
 *
 * NÃO envolve `/telao` nem `/sala`: o telão é projeção pura (05/08, sem
 * elemento clicável) e a sala é o aluno DENTRO da aula — menu ali é convite pra
 * sair no meio. As duas ficam fora da casca no `App.tsx`, não por condicional
 * aqui, pra a decisão ficar legível na tabela de rotas.
 *
 * Spec: .planning/IDENTIDADE-E-NAVEGACAO.md (B3)
 */
import { useLocation } from 'react-router-dom';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { MenuLateral } from './MenuLateral';
import { usePapel } from '@/hooks/usePapel';
import { itemDoCaminho, TEM_MENU_LATERAL } from '@/lib/navegacao';


/** A barra fina do celular: o gatilho da gaveta e onde a pessoa está. */
function BarraDoCelular() {
  const { pathname } = useLocation();
  const { papel } = usePapel();
  const item = itemDoCaminho(papel, pathname);

  return (
    <div className="sticky top-0 z-20 flex h-12 items-center gap-2 border-b border-border bg-background/95 px-2 backdrop-blur md:hidden">
      <SidebarTrigger />
      {/* O título vem do MENU, não da página: é o que estava aceso na gaveta,
          então a barra confirma a escolha em vez de contar outra história. */}
      <span className="truncate text-sm font-medium">{item?.rotulo ?? ''}</span>
    </div>
  );
}

export function Casca({ children }: { children: React.ReactNode }) {
  if (!TEM_MENU_LATERAL) return <>{children}</>;

  return (
    <SidebarProvider>
      <MenuLateral />
      <SidebarInset>
        <BarraDoCelular />
        {children}
      </SidebarInset>
    </SidebarProvider>
  );
}
